import React from "react";

//Panels
import Types from "./Panels/Stones";
import Finishes from "./Panels/Finishes";
import Shapes from "./Panels/Shapes";
import Patterns from "./Panels/Patterns";

//SEO
import SEO from "../../../../SEO/index.js";

const Variations = () => {
  return (
    <>
      <SEO
        title="Types of Stone Pavers | Patios & Driveways | Pacific Pavingstone"
        description="Learn the differences between regular and permeable stones and the different finishes, shapes, and patterns we offer for your next pavingstone project."
        profileURL={"https://www.pacificpavingstone.com/styles/variations"}
        type="website"
      />
      <div className="row justify-content-center">
        <div className="col-11 col-xl-10 page-variations">
          <Types />
          <Finishes />
          <Shapes />
          <Patterns />
        </div>
      </div>
    </>
  );
};

export default Variations;
